import * as React from "react";
function SvgChevronUpSm(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <g clipPath="url(#chevron-up-sm_svg__clip0_131_25)">
                <path
                    d="M12.014 8.24a1.15 1.15 0 01.865.39l4.905 5.576a.924.924 0 01-1.386 1.22l-4.29-4.877a.125.125 0 00-.188 0l-4.29 4.876a.923.923 0 11-1.386-1.22l4.904-5.573a1.156 1.156 0 01.866-.392z"
                    fill="currentcolor"
                />
            </g>
            <defs>
                <clipPath id="chevron-up-sm_svg__clip0_131_25">
                    <path fill="#fff" d="M0 0h24v24H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgChevronUpSm);
export default ForwardRef;
